import { useState, useContext, useEffect } from "react";
import DataContext from "../../context/data-context";
import VehicleCard from "./VehicleCard";
import SearchBar from "../UI/SearchBar";
import Heading from "../UI/Heading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdAdd, MdRefresh } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import { requestPartnerAPI } from "../../api/server";
import PaginationMenu from "../UI/PaginationMenu";
import NoRecordsFound from "../UI/NoRecordsFound";
import LoadingCard from "../UI/LoadingCard";
import ListLabels from "../UI/ListLabels";
import { UtilityContext } from "../../context/util-context";
import VehiclesTour from "../tours/VehiclesTour";

export default function Vehicles() {
  const { navigate } = useContext(UtilityContext);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Default filter
  const defaultFilters = {
    query: "",
    limit: 50,
  };

  // Filters in URL params
  const paramFilters = {};
  Object.keys(defaultFilters).forEach(
    (key) => (paramFilters[key] = params.get(key) ?? defaultFilters[key])
  );

  // Initialize States
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(paramFilters);
  const [records, setRecords] = useState([]);

  /* ======================= FETCH RECORDS ======================= */
  const fetchRecords = async () => {
    try {
      setLoading(true);
      // Fetch records based on filter
      const data = await requestPartnerAPI("fetch-vehicles", filter);
      setRecords(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Fetch on load or change of filter
  useEffect(() => {
    fetchRecords();
  }, [filter]);
  return (
    <div className="grid gap-4 overflow-hidden bg">
      
      <Heading
        title="Vehicles"
        description="This lists shows all onboarded and requested vehicles. To add a new vehicle application, click 
          the '+' icon on the right. The icons on the right represent different statuses - hover over them to see details."
      >
        <div
          data-tour="vehicles-add"
          onClick={(e) => navigate("/vehicles/add", e)}
          className="flex items-center space-x-2 text-sm btn-secondary"
        >
          <p className="text-stone-200">Add Vehicle</p>
          <MdAdd className="text-xl text-stone-200" />
        </div>
      </Heading>
      <SearchBar
        searchHandler={(query) => setFilter({ ...filter, query })}
        clearSearch={() => setFilter(defaultFilters)}
        searchValue={filter.query}
      />
      {loading ? (
        <LoadingCard max={6} />
      ) : records.length > 0 ? (
        <div className="grid gap-2">
          <div className="labels lg:grid-cols-7">
            <ListLabels
              labels={[
                "",
                { name: "Vehicle", classes: "lg:col-span-2" },
                "VIN",
                "Institution/Due Date",
                "Monthly Payment",
                "",
              ]}
              selected={filter.sort}
              setSelected={(sort) => setFilter({ ...filter, sort })}
            />
          </div>

          <div className="list">
            {records?.map((vehicle, idx) => (
              <VehicleCard key={idx} vehicle={vehicle} />
            ))}
          </div>
        </div>
      ) : (
        <NoRecordsFound />
      )}

      <PaginationMenu
        limit={filter.limit}
        setLimit={(l) => setFilter({ ...filter, limit: l })}
        loading={loading}
        count={records.length}
      ></PaginationMenu>
    </div>
  );
}
